import React from 'react';
import { testimonials } from '../data/mock';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section className="section-padding bg-[#1a1a1a]">
      <div className="container-custom">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="gold-accent mx-auto mb-6"></div>
          <h2 className="font-serif text-3xl md:text-4xl text-[#fffef8] mb-6">
            What Our Members Say
          </h2>
          <p className="text-[#b8b8b8] text-lg leading-relaxed">
            The experiences of those who have made the transition to concierge medicine 
            speak to the profound difference in care.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-[#252525] p-8 relative"
            >
              <Quote size={32} className="text-[#c9a962] opacity-50 mb-6" />
              <p className="text-[#e8e8e8] leading-relaxed mb-8 font-light italic">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-[#3a3a3a] pt-6">
                <p className="text-[#fffef8] font-medium">{testimonial.author}</p>
                <p className="text-[#8a8a8a] text-sm">{testimonial.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
